import { withRouter } from 'react-router-dom';

export const InvoiceTypeCodeMap = new Map(
  [
    ['0', '未知发票类型'],
    ['01', '增值税专用发票'],
    ['04', '增值税普通发票'],
    ['03', '机动车销售统一发票'],
    ['10', '增值税普通发票(电票)'],
    ['11', '增值税普通发票(卷票)'],
    ['14', '增值税普通发票(通行费)'],
  ]
);

export enum documnetStatusEnum {
  DRAFT = '草稿',
  SENT = '发送',
  RECEIVED = '接收',
  ACCEPTED = '接受',
  REJECTED = '拒绝',
  NO_STATUS = '',
  CANCEL_REQUESTING = '',
  CANCEL_REJECTED = '取消拒绝',
  CANCELED = '已作废',
}

export enum differenceCode {
  LineExtensionAmount = '金额',
  TaxInclusiveAmount = '价税合计',
}

export const withRouterOuter = (cla: any): any => {
  return withRouter(cla);
};

export interface PageMeta {
  pageNum: number;
  pageSize: number;
  pages: number;
  total: number;
}

// 判断是否为一个空对象
export function isNullObj (obj: object): boolean {
  return Object.keys(obj).length === 0;
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/unit.ts